import React from 'react'
import { Palette, TableCell, Tooltip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { truncateString } from '../../../../utils/TruncateString/TruncateString'
import { capitalizeFirstLetter } from '../../../../utils/CapitalizeFirstLetter/CapitalizeFirstLetter'
import { TableCellProps } from '@mui/material/TableCell/TableCell'

const tableCellStyle = (palette: Palette) => ({
	maxWidth: 150,
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	cursor: 'pointer',
	color: palette.text.darkGrey,
	border: 'none',
})

interface CustomTableCellProps extends TableCellProps {
	text: string
}

export default function CustomTableCell({ text, ...props }: CustomTableCellProps) {
	const { palette } = useTheme()
	// Check if text is a boolean and convert to a more readable format, then capitalize
	const displayText = typeof text === 'boolean' ? (text ? 'Yes' : 'No') : text
	const capitalizedText = displayText ? capitalizeFirstLetter(String(displayText)) : displayText

	return (
		<Tooltip title={String(capitalizedText)} placement="top" arrow>
			<TableCell {...props} sx={tableCellStyle(palette)}>
				{capitalizedText ? truncateString(String(capitalizedText), 60) : '-'}
			</TableCell>
		</Tooltip>
	)
}
